module.exports = __webpack_public_path__ + "assets/b108.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b108.png
// module id = 579
// module chunks = 0